import { map } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { Blocs } from '@business/blocs';
import { LoadingState } from '@core/utils/repository/loading_state';
import { forkJoin } from 'rxjs';
import { CommonService } from '@business/services';

export class NewTaskBloc extends BaseBloc {
  private readonly userBloc = resolve(Blocs.user);
  private readonly taskBloc = resolve(Blocs.todo);
  private readonly orgBloc = resolve(Blocs.organization);

  readonly loading = new LoadingState({ loading: false });
  readonly users$ = this.userBloc.staff$;
  onInit() {
    return forkJoin(this.userBloc.fetchUsers()).pipe(this.loading.run());
  }

  createTask = this.taskBloc.createTask;
  updateTask = this.taskBloc.updateTask;

  searchOrganizations = (search: string) => {
    return this.orgBloc.searchOrganizations(search).pipe(map(data => CommonService.selectItems(data.data, 'name', 'id')));
  };
}
